





















import { Component, Vue, Prop } from 'vue-property-decorator';

import Button from 'frontend/components/Button.vue';
import ResponsiveImage from 'frontend/components/ResponsiveImage.vue';

@Component({
  components: {
    ResponsiveImage,
    Button,
  },
  computed: {},
})
export default class PaywallFooterCta extends Vue {
  @Prop({ type: String, default: 'Subscribe' }) private readonly ctaText!: string;
  private handleClick(): void {
    this.$emit('footer-cta-clicked');
  }
}
